import { css } from '@emotion/react'
import { graphql } from 'gatsby'
import { type ComponentProps, Fragment } from 'react'
import { renderMarkRule } from 'react-datocms/structured-text'

import { DatoStructuredText } from '@/features/common'
import { bodyHeading } from '@/features/page-sections'

interface Props extends ComponentProps<'div'> {
  data: Queries.MilestoneGroupFragment | null
}

export const MilestoneGroup = ({ data, ...props }: Props) => {
  const styles = {
    container: css``,
    heading: css`
      font-size: var(--fs-36);
      margin: 1em 0 0.5em;
    `,
    list: css`
      display: grid;
      grid-template-columns: auto 1fr;
      row-gap: 0.67em;
      column-gap: 1em;
      margin: 0;
      padding: 0;
      list-style: none;
    `,
    listItem: css`
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: subgrid;
      p {
        margin: 0;
      }
    `,
    year: css``,
    description: css``,
  }
  return (
    <div
      css={styles.container}
      {...props}
    >
      {data?.heading && <h2 css={styles.heading}>{data.heading}</h2>}
      <ul css={styles.list}>
        {data?.milestones?.map((milestone, i) => (
          <li
            css={styles.listItem}
            key={i}
          >
            <div css={styles.year}>{milestone?.year || ''}</div>
            <div css={styles.description}>
              <DatoStructuredText
                data={milestone?.description}
                customMarkRules={[
                  renderMarkRule(
                    'highlight',
                    ({ adapter: { renderNode }, children, key }) => {
                      const childrenTyped = children as unknown as {
                        props: {
                          children: string[]
                        }
                      }
                      const text = childrenTyped?.props
                        ?.children?.[0] as string
                      const spannedText = text
                        ? text.split(' ').map((word, i, array) => {
                            const isCapitalized =
                              word[0] === word[0].toUpperCase()
                            return (
                              <Fragment key={i}>
                                <span
                                  data-capitalized={
                                    isCapitalized || undefined
                                  }
                                >
                                  {word}
                                </span>
                                {i < array.length - 1 && ' '}
                              </Fragment>
                            )
                          })
                        : undefined
                      return renderNode(
                        'mark',
                        { key },
                        spannedText || children
                      )
                    }
                  ),
                ]}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export const MilestoneGroupFragment = graphql`
  fragment MilestoneGroup on DatoCmsMilestoneGroup {
    __typename
    id: originalId
    heading
    milestones {
      year
      description {
        value
      }
    }
  }
`
